<div class="input-wrapper fx fx-row fx-gap-1em fx-align-start">
  <mat-checkbox [checked]="paginationEnabled" (change)="paginationEnabled = !paginationEnabled"> Show Pagination </mat-checkbox>
  <mat-checkbox [checked]="filterEnabled" (change)="filterEnabled = !filterEnabled"> Show Filter </mat-checkbox>
</div>

<mad-data-table
  [idGenerator]="idGenerator"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [actions]="actions"
  [paginationEnabled]="paginationEnabled"
  [pageSizeOptions]="[5, 10, 15]"
  [defaultPageSize]="10"
  (actionEvent)="handleActionEvent($event)"
>
</mad-data-table>
